import React from 'react';
import Loader from 'src/components/Loader/Loader';
import './load-state.scss';

export interface LoadStateProps {
  isLoading: boolean;
  isEmpty?: boolean;
  error?: string | null;
  emptyNode?: React.ReactNode;
  errorNode?: React.ReactNode;
  loadingNode?: React.ReactNode;
  children: React.ReactNode;
}

const LoadState = ({
  isLoading,
  isEmpty = false,
  error = null,
  emptyNode = null,
  errorNode = null,
  loadingNode = null,
  children,
}: LoadStateProps) => {
  if (error) {
    return (
      <div className="load-state">
        <div className="load-state-fill">
          {errorNode ?? <div className="load-state-error">{error}</div>}
        </div>
      </div>
    );
  }

  if (isLoading) {
    return (
      <div className="load-state">
        <div className="load-state-fill">
          {loadingNode ?? <Loader imageHeight="10rem" imageWidth="10rem" />}
        </div>
      </div>
    );
  }

  if (isEmpty) {
    return (
      <div className="load-state">
        <div className="load-state-fill">{emptyNode}</div>
      </div>
    );
  }

  return <>{children}</>;
};

export default LoadState;
